import { combineReducers } from 'redux';
import app from './app';
import auth from './auth';
import user from './user';
import ad from './ad';
import content from './content'
import match from './match';

export const handleReducer = (listHandler: any, state: any, action: any) => {
    if (listHandler[action.type]) {
        return listHandler[action.type](state, action.payload);
    }
    return { ...state };
};


const rootReducer = combineReducers({
    app,
    auth,
    user,
    ad,
    content,

    // soccer
    match
});

export default rootReducer;
